import script from "./receive.vue?vue&type=script&setup=true&lang=js"
export * from "./receive.vue?vue&type=script&setup=true&lang=js"

import "./receive.vue?vue&type=style&index=0&id=6796193d&lang=less&scoped=true"

import exportComponent from "E:\\zhengbo-supplychain\\web-supplychain\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6796193d"]])

export default __exports__